import {BaseService} from "./BaseService";
import {Printer} from "../entities/Printer";
import { StateService } from "@uirouter/angularjs";

export class PrinterService extends BaseService<Printer>{
        static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
            super($http, $q, $state, Printer);
        }
        protected getBaseUrl():string{
            return "printer";
        }
    }
